import { apiGet, apiPost, apiPut, apiDelete } from "./client";

export interface ProviderConfig {
  providerId: string;
  type: "ats" | "board" | "local-parser" | "signal";
  name: string;
  description: string;
  enabled: boolean;
  /** True when Zero has a runtime adapter */
  implemented?: boolean;
  defaultConfig: Record<string, unknown>;
  userOverrides: Record<string, unknown>;
  urlPattern?: string;
  allowedHosts?: string[];
  supportsDetect?: boolean;
  supportsApiUrl?: boolean;
  features?: string[];
  timeoutMs?: number;
  retryPolicy?: string;
  website?: string;
  docsUrl?: string;
  lastPullAt?: string;
  createdAt?: string;
  updatedAt?: string;
}

export async function listProviders(): Promise<ProviderConfig[]> {
  const res = await apiGet<{ providers: ProviderConfig[] }>("/api/providers");
  return res.providers ?? [];
}

export async function getProvider(id: string): Promise<ProviderConfig> {
  const res = await apiGet<{ provider: ProviderConfig }>(`/api/providers/${id}`);
  return res.provider;
}

export async function updateProvider(id: string, updates: Partial<ProviderConfig>): Promise<ProviderConfig> {
  const res = await apiPut<{ provider: ProviderConfig }>(`/api/providers/${id}`, updates);
  return res.provider;
}

export async function discoverProviders(): Promise<{ discovered: number; providers: ProviderConfig[] }> {
  const res = await apiPost<{ message: string; seeded: string[] }>("/api/providers/discover");
  return { discovered: res.seeded?.length ?? 0, providers: [] };
}

export async function deleteProvider(id: string): Promise<void> {
  await apiDelete(`/api/providers/${id}`);
}